import usePage from "./usePage";

export function usePublicationSubdomain(): string {
  const {props} = usePage<AdminUsePageProps>();

  if (typeof window === "undefined") return "";

  return `${window.location.origin}/admin/${props.publication.slug}`
}